import { monthIndexToMonth } from 'api/recommendations'
import moment from 'moment'

interface Props {
  checkIn?: string
  monthIndex?: string
  duration: number
  dayTitleTemplate: string
  monthTitleTemplate: string
  defaultTitle: string
}

export function getRecommendationsTitle({
  checkIn,
  monthIndex,
  duration,
  dayTitleTemplate,
  monthTitleTemplate,
  defaultTitle,
}: Props): { title: string, subtitle?: string } {
  if (checkIn) {
    const displayFormat = 'D MMM'
    const from = moment(checkIn).format(displayFormat)
    const to = moment(checkIn).add(duration, 'days').format(displayFormat)
    const title = 'Best offers for your dates'
    const subtitle = dayTitleTemplate.replace('{from}', from).replace('{to}', to).replace('{duration}', `${duration} night${duration === 1 ? '' : 's'}`)
    return {
      title,
      subtitle,
    }
  }
  if (monthIndex) {
    return {
      title: monthTitleTemplate.replace('{month}', moment(monthIndexToMonth(monthIndex), 'M-YYYY').format('MMMM')),
    }
  }
  return { title: defaultTitle }
}

export function getRecommendationsTitleMobile({
  checkIn,
  monthIndex,
  duration,
  dayTitleTemplate,
  monthTitleTemplate,
  defaultTitle,
}: Props): string {
  if (checkIn) {
    const displayFormat = 'DD MMM'
    const from = moment(checkIn).format(displayFormat)
    const to = moment(checkIn).add(duration, 'days').format(displayFormat)
    return dayTitleTemplate.replace('{from}', from).replace('{to}', to)
  }
  if (monthIndex) {
    return monthTitleTemplate.replace('{month}', moment(monthIndexToMonth(monthIndex), 'M-YYYY').format('MMMM'))
  }
  return defaultTitle
}
